import Reveal from "@/components/Reveal";
import { ArrowRight, ArrowUpRight } from "lucide-react";

export default function FinalCta() {
  return (
    <section className="bg-[#F3F0E8] text-[#09090B] relative overflow-hidden">
      <span
        aria-hidden="true"
        className="font-serif-d font-black text-outline-dark absolute -bottom-10 left-0 text-[22vw] leading-none whitespace-nowrap select-none pointer-events-none"
      >
        PRESENCE
      </span>
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-28 sm:py-40">
        <Reveal>
          <h2
            data-testid="final-cta-heading"
            className="font-serif-d font-black tracking-tight leading-[1.0] text-4xl sm:text-6xl lg:text-8xl max-w-6xl"
          >
            If you know what you want to be known for,{" "}
            <span className="italic font-semibold text-[#118C4F]">
              I'll build the presence around it.
            </span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="flex flex-col sm:flex-row gap-4 mt-14">
            <a
              href="#contact"
              data-testid="final-cta-primary"
              className="group inline-flex items-center justify-center gap-2 bg-[#09090B] hover:bg-[#118C4F] hover:text-[#09090B] text-[#F3F0E8] font-medium px-8 py-4 text-base transition-colors duration-300"
            >
              Request a discover call
              <ArrowRight size={17} strokeWidth={2.2} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="https://www.linkedin.com/in/iambaishali/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-linkedin"
              aria-label="Connect on LinkedIn"
              className="group inline-flex items-center justify-center gap-2 border border-[#09090B]/25 hover:border-[#09090B] text-[#09090B] font-medium px-8 py-4 text-base transition-colors duration-300"
            >
              Connect on LinkedIn
              <ArrowUpRight size={17} strokeWidth={2.2} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
